import { DataTableMessages, TranslationDataTableMessages } from "../interfaces";

export const messages: TranslationDataTableMessages = {
  [DataTableMessages.status]: "Status",
  [DataTableMessages.actions]: "Acciones",
  [DataTableMessages.buttonsAddNew]: "Agregar nuevo",
  [DataTableMessages.buttonsExport]: "Exportar",
  [DataTableMessages.buttonsUnifiedExport]: "Exportar a lista unificada",
  [DataTableMessages.buttonsGroupedExport]: "Exportación en modelo agrupado",
  [DataTableMessages.buttonsPrint]: "Imprimir",
  [DataTableMessages.buttonsRefresh]: "Actualizar",
  [DataTableMessages.emptyTable]: "No se encontraron registros",
  [DataTableMessages.info]: "Mostrando _START_-_END_ de _TOTAL_ registros",
  [DataTableMessages.infoEmpty]: "Mostrando 0-0 de 0 registros",
  [DataTableMessages.infoPaginated]: "Mostrando _START_-_END_ de _TOTAL_ cargados <br/> Total de _REAL_TOTAL_ registros",
  [DataTableMessages.infoFiltered]: "(Filtrados de _MAX_ registros)",
  [DataTableMessages.lengthMenu]: "_MENU_ registros por página",
  [DataTableMessages.loadingRecords]: "Cargando...",
  [DataTableMessages.processing]: "Procesando...",
  [DataTableMessages.zeroRecords]: "No se encontraron registros",
  [DataTableMessages.search]: "Buscar...",
  [DataTableMessages.searchPlaceholder]: "Filtrar datos en pantalla...",
  [DataTableMessages.filterTitle]: "Filtros",
  [DataTableMessages.filterApplied]: "Filtros aplicados a",
  [DataTableMessages.filterNoneApplied]: "No hay filtros aplicados",
  [DataTableMessages.filterCorrespondence]: "Correspondencia de todos estos filtros",
  [DataTableMessages.filterAdd]: "Agregar filtro",
  [DataTableMessages.filterRemoveAll]: "Remover todos",
  [DataTableMessages.filterApply]: "Aplicar filtro",
  [DataTableMessages.filterNewFilterField]: "Nuevo filtro de campo",
  [DataTableMessages.filterOperatorEquals]: "Igual a",
  [DataTableMessages.filterOperatorNotEquals]: "Diferente de",
  [DataTableMessages.filterOperatorStartsWith]: "Comienza con",
  [DataTableMessages.filterOperatorContains]: "Contiene",
  [DataTableMessages.filterOperatorNotContains]: "No contiene",
  [DataTableMessages.filterOperatorGreaterThan]: "Mayor que",
  [DataTableMessages.filterOperatorLessThan]: "Menor que",
  [DataTableMessages.filterOperatorGreaterThanOrEqual]: "Mayor o igual a",
  [DataTableMessages.filterOperatorLessThanOrEqual]: "Menor o igual a",
  [DataTableMessages.filterProperty]: "Propiedad",
  [DataTableMessages.filterValue]: "Valor",
  [DataTableMessages.filterOperator]: "Operador",
  [DataTableMessages.moreRecords]: "Cargar más registros",
  [DataTableMessages.buttonsViewRoles]: "Cargos",
  [DataTableMessages.reportDriverRolesLabel]: "informe_conductor_cargos",
  [DataTableMessages.modalExportTitle]: "Exportar datos",
  [DataTableMessages.modalExportDescription]: "Exportando solo _LOADED_/_TOTAL_ registros cargados. \n "
    + "Para incluir todos los datos filtrados, programe un Informe Completo.",
  [DataTableMessages.modalButtonExportPartial]: "Exportar datos cargados",
  [DataTableMessages.modalButtonScheduleExport]: "Programar informe completo",
  [DataTableMessages.selectedSingular]: "elemento seleccionado",
  [DataTableMessages.selectedPlural]: "elementos seleccionados",
  [DataTableMessages.clearSelection]: "Limpiar selección",
  [DataTableMessages.selectAll]: "Seleccionar todos"
};
